import { ExpensePage } from "@/pages/VendorExpenses";

export default function InternalExpenses() {
  return <ExpensePage kind="internal" num="16" title="Internal Expenses" subtitle="Staff expenses and receipts — multiple entries per project, approval separate from payment." />;
}
